import { URL_HOST } from "./constant";

export const APP_ROOT_PROTOCOL = window.location.protocol;
export const APP_ROOT_HOSTNAME = window.location.hostname;
export const APP_ROOT_PORT = window.location.port;

export const APP_ROOT_REMOTE = `${URL_HOST}`;
export const APP_ROOT_DEVICE = `${APP_ROOT_PROTOCOL}//${APP_ROOT_HOSTNAME}:${APP_ROOT_PORT}`;
export const APP_ROOT =
  process.env.NODE_ENV === "development" ? APP_ROOT_REMOTE : APP_ROOT_DEVICE;
export const ENABLED_UPDATE_SOFTWARE = process.env.NODE_ENV !== "development";
export const ENABLED_FIRST_TARE = process.env.NODE_ENV !== "development";
export const IS_DEVELOPMENT_MODE = process.env.NODE_ENV === "development";
export const ENABLED_TRIAL_LICENSE_MODAL =
  process.env.NODE_ENV !== "development";
export const PC_SERVICE_ADDRESS = `${APP_ROOT_PROTOCOL}//${APP_ROOT_HOSTNAME}:9002`;
export const NO_LIMIT = Infinity;
export const STARTING_VOLUME_DIFFERENCE = 0.2;
export const CURRENT_BUFFER_EXCHANGE_VOL_THRESHOLD = 2;
export const RECOVERY_FINAL_VOL_THRESHOLD = 3;
export const REFILL_BUFFER_EXCHANGE_VOL_THRESHOLD = 3;
const EMPTY_FIELD = "9999999999";

export const CONICAL_VOLUME = {
  FIFTY: 50,
  FIFTEEN: 15,
};

export const USB_FLASH = {
  MOUNT_POINT: "/media/usbflash",
  PARTITION_USB_FLASH: "/dev/sda1",
  LOG_DIRECTORY: "/media/usbflash/PULSE_TFF_LOG",
  CYCLE_HISTORY_PARENT_PATH: "/home/pi/ProteinConcentrator/Log/CycleLog/",
  CEK_USB_TIME_OUT: 15,
};
export const VOLUME_SENSOR = {
  INCREMENT_VALUE: 0.1,
  DECIMAL_PLACE_ACCURACY: 2,
  MAX_VALUE: EMPTY_FIELD,
  MIN_VALUE: 1,
  MIN_CONCENT_VALUE: 1.2,
  MIN_STEP_SIZE: 0.2,
  MAX_EXCHANGE_VOLUME: 300,
};
export const BUFFER_REFILL = {
  INCREMENT_VALUE: 0.1,
  DECIMAL_PLACE_ACCURACY: 2,
  MAX_VALUE: 53,
  MIN_VALUE: 1,
  MAX_EXCHANGE_VOLUME: 300,
  REQUIRES_REFILL_VALUE: 3,
};
export const BUFFER_FINAL_VOLUME_SENSOR = {
  INCREMENT_VALUE: 0.1,
  DECIMAL_PLACE_ACCURACY: 2,
  MAX_VALUE: 50,
  MIN_VALUE: 1,
  MAX_EXCHANGE_VOLUME: 300,
};
export const BUFFER_EXCHANGE_SENSOR = {
  MAX_VALUE: 50,
  MIN_VALUE: 1,
  MIN_VOLUME_IN_ONE_EXCHANGE: 0.75,
  DEFAULT_STEP_SIZE: 1,
};
export const CONCENTRATE_SENSOR = {
  INCREMENT_VALUE: 0.0001,
  DECIMAL_PLACE_ACCURACY: 99,
  FIXED_VALUE: 7,
  MAX_VALUE: 1000,
  MIN_VALUE: 0.001,
};

export const VOLUME_MANUAL_CONTROL = {
  MAX_VALUE: 100,
  MIN_VALUE: 0.2,
  DECIMAL_PLACE_ACCURACY: 1,
};

export const PRESSURE_SETTINGS = {
  DECIMAL_PLACE_ACCURACY: 0,
  INC_VALUE: 1,
  MAX_VALUE: 40,
  MIN_VALUE: 3,
};
export const THRESHOLD_SETTINGS = {
  DECIMAL_PLACE_ACCURACY: 2,
  INC_VALUE: 0.01,
  MAX_VALUE: 2,
  MIN_VALUE: 0,
};

export const RECOVERY_OF_LIQUID = {
  MAX_VOLUME_IN_CHIP: 0.5,
  VOLUME_ADD_EVERY_PUMP_AIR_RECOVERY: 0.077,
  VOLUME_ADD_EVERY_PUMP_BUFFER_RECOVERY: 0.062,
  DECIMAL_PLACE_ACCURACY: 3,
};

// status
export const INTERVAL = {
  STATUS_TIME_UPDATE: 2000,
  GET_WIFI: 10000,
  DEBUG_TIMING_UPDATE: 1500,
};

export const VOLUME_BUFFER_RECOVERY = {
  MAX_VALUE: 0.35,
  MIN_VALUE: 0.05,
  DECIMAL_PLACE_ACCURACY: 2,
};

export const VOLUME_AIR_RECOVERY = {
  MAX_VALUE: 0.46,
  MIN_VALUE: 0.11,
  DECIMAL_PLACE_ACCURACY: 2,
};

export const CONCENTRATION_CALCULATION = {
  MIN_TUBE_VOLUME: 1.49,
  LIQUID_VOLUME_IN_CHIP: 0.49,
};

export const TARGET_VOLUME = {
  INCREMENT_VALUE: 0.1,
  DECIMAL_PLACE_ACCURACY: 2,
  MIN_VALUE: 0,
};

export const SCHEDULE_PROFILE_HOURS = {
  INCREMENT_VALUE: 1,
  DECIMAL_PLACE_ACCURACY: 0,
  MIN_VALUE: 0,
  MAX_VALUE: 72,
};

export const SCHEDULE_PROFILE_MINUTES = {
  INCREMENT_VALUE: 1,
  DECIMAL_PLACE_ACCURACY: 0,
  MIN_VALUE: 0,
  MAX_VALUE: 59,
};
